export const ADD_EDUCATION_STARTED =
  'ADD_EDUCATION_STARTED';
export const ADD_EDUCATION_SUCCESS =
  'ADD_EDUCATION_SUCCESS';
export const ADD_EDUCATION_ENDED = 'ADD_EDUCATION_ENDED';
export const ADD_EDUCATION_ERROR = 'ADD_EDUCATION_ERROR';
